import { validateEvmAddress, validateSolAddress } from './addressUtils'

// Shortens blockchain addresses by showing only the start and end characters with an ellipsis in between
export const truncateAddress = (
    address: string,
    opts: {
        evmPrefixLen: number
        evmSuffixLen?: number
        solanaPrefixLen?: number
        solanaSuffixLen?: number
        tronPrefixLen?: number
        tronSuffixLen?: number
    } = {
        evmPrefixLen: 4,
        evmSuffixLen: 4,
        solanaPrefixLen: 5,
        solanaSuffixLen: 6,
        tronPrefixLen: 4,
        tronSuffixLen: 4,
    }
) => {
    if (!address || address === '') return 'No Account'

    // Match Ethereum-style addresses (0x...)
    const ethMatch = validateEvmAddress(address)
    // remove the leading 0x
    address = address.slice(2)
    if (ethMatch)
        return `0x${address.slice(0, opts.evmPrefixLen!)}…${address.slice(address.length - opts.evmSuffixLen!)}`

    // Match Solana-style addresses (Base58 string)
    const solMatch = validateSolAddress(address)
    if (solMatch)
        return `${address.slice(0, opts.solanaPrefixLen!)}…${address.slice(address.length - opts.solanaSuffixLen!)}`

    // Match TRON-style addresses (Base58 string starting with 'T')
    const tronMatch = address.match(
        new RegExp(`^(T[a-zA-Z0-9]{${opts.tronPrefixLen}})[a-zA-Z0-9]+([a-zA-Z0-9]{${opts.tronSuffixLen}})$`)
    )
    if (tronMatch) return `${tronMatch[1]}…${tronMatch[2]}`

    // If address already contains '...', return as is
    if (address.includes('...')) return address
    // Otherwise truncate if long enough
    return address.length > 8 ? `${address.slice(0, 4)}…${address.slice(-4)}` : address
}
